import { render, staticRenderFns } from "./city-selector.vue?vue&type=template&id=45a11485&"
import script from "./city-selector.vue?vue&type=script&lang=js&"
export * from "./city-selector.vue?vue&type=script&lang=js&"
import style0 from "./city-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports